import * as http from './http';

export function destroyImage(id: number) {
  return http.destroy(`/api/v1/admin/image/${id}`);
}
